import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-child-line",
  "use": "icon-child-line-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-child-line\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 20V10h2v8h14v2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol